import { Pipe, PipeTransform } from '@angular/core';
import { Trans_pt } from 'src/app/consts/translate_pt';
import { Trans_eng } from '../../consts/translate_eng';
import { Trans_esp } from '../../consts/translate_esp';
import { GlobalService } from '../services/global.service';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {

	transform(value: string): any {
		var e: any;
		if (this._gS.getLenguage() === 'eng') {
			e = Trans_eng[value.toLowerCase()]
		} else if (this._gS.getLenguage() === 'esp') {
			e = Trans_esp[value.toLowerCase()]
		}
		else {
			e = Trans_pt[value.toLowerCase()]
		}
		if (e) {
			return e
		} else {
			return value
		}
	}
	constructor(public _gS: GlobalService) {

	}

}
